import axios from 'axios'
import { EVENT_PERSONNEL_POOL, USER_TOKEN, EVENT_PERSONNEL, EVENT_SUPPLIER_PERSONNEL_UPDATE, EVENT_PERSONNEL_LIST_FOR_CHEF, EVENT_PERSONNEL_QUICK_INSERT, EVENT_PERSONNEL_BULK_INSERT, EVENT_PERSONNEL_CHECK } from "./CONSTANTS";

export const getEventPersonnelPool = () => {
  console.info("eventServices > getEvents...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PERSONNEL_POOL(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventPersonnelPool = (model) => {
  console.info("eventServices > addEvent...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PERSONNEL_POOL(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventPersonnelPool = (model) => {
  console.info("updateServices > updateEvent...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_PERSONNEL_POOL(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventPersonnelPool = (uniqueKey) => {
  console.info("eventServices > deleteEvent...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_PERSONNEL_POOL()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


export const getEventPersonnels = (uniqueKey,isSupplier, format, type, supplierUniqueKey, allData) => {
  console.info("eventPersonnelServices > getEventPersonnels...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PERSONNEL()+"?uniqueKey="+uniqueKey+(isSupplier?"&supplier=1":"")+(format?"&format="+format:"")+(type?"&type="+type:"")+(supplierUniqueKey?"&s="+supplierUniqueKey:"")+(allData?"&all=1":""),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        },
        responseType: format && format =='excel' ?'blob':'json'
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventPersonnel = (model) => {
  console.info("eventPersonnelServices > addEventPersonnel...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PERSONNEL(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const deleteEventPersonnel = (uniqueKey) => {
  console.info("eventPersonnelServices > deleteEventPersonnel...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_PERSONNEL()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventPersonnel = (model) => {
  console.info("updateServices > updateEventPersonnel...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_PERSONNEL(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const checkEventPersonnel = (model) => {
  console.info("eventPersonnelServices > checkEventPersonnel...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PERSONNEL_CHECK(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const updateEventSupplierPersonnel = (model) => {
  console.info("eventPersonnelServices > addEventPersonnel...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_SUPPLIER_PERSONNEL_UPDATE(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


export const getEventPersonnelsForChef = (uniqueKey) => {
  console.info("eventPersonnelServices > getEventPersonnelsForChef...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PERSONNEL_LIST_FOR_CHEF()+"?uniqueKey="+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventPersonnelQuickInsert = (model) => {
  console.info("eventPersonnelServices > addEventPersonnelQuickInsert...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PERSONNEL_QUICK_INSERT(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const addEventPersonnelBulkInsert = (model) => {
  console.info("eventPersonnelServices > addEventPersonnelBulkInsert...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_PERSONNEL_BULK_INSERT(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};